'use strict';

var Bacon, Dispatcher, PlatformUtils, R, acceptOnlineOrders, addressStore, browser, busyStream, cartKey, cartParams, cartSavingStream, cartState, cartStreamData, cartStreamErrors, cartUpdated, cartUpdates, createCart, d, getCartURL, hasErrors, integrationStore, isStreamLoading, loadCart, loadCartFromURL, loadingIndicators, makeErrorIfNull, _merger, notNil, portalStore, reloader, resUtil, restaurant, restaurantIntegration, restaurantStore, serviceUnavailable, storage, totalDetailsStream, totalReloader, _updateSettings, userId, userStore, validateCart;

Bacon = require('baconjs');

R = require('ramda');

integrationStore = require('../integration');

restaurantStore = require('../restaurant');

userStore = require('../user');

addressStore = require('../address');

portalStore = require('../portal');

resUtil = require('../../utils/resources');

browser = require('../../utils/browser');

storage = require('../../utils/storage');

PlatformUtils = require('../../utils/platform');

Dispatcher = require('../../utils/dispatcher');

d = new Dispatcher('cart');

cartKey = function cartKey(permalink) {
  return 'CART-5@#' + permalink;
};

makeErrorIfNull = R.curry(function (errPass, res) {
  if (res) {
    return new Bacon.Next(res);
  } else {
    return new Bacon.Error(errPass);
  }
});

restaurantIntegration = integrationStore.current;

restaurant = restaurantStore.restaurant;

_merger = function merger(k, l, r) {
  if (R.is(Object, l) && R.is(Object, r)) {
    return R.mergeWithKey(_merger, l, r);
  } else {
    return r;
  }
};

userId = userStore.user.map(R.prop('id')).skipDuplicates(R.equals);

createCart = function createCart(payload) {
  return Bacon.retry({
    source: function source() {
      return resUtil.createResource(payload);
    },
    retries: 3,
    isRetryable: function isRetryable() {
      return true;
    },
    delay: function delay(_ref) {
      var error = _ref.error,
          retriesDone = _ref.retriesDone;

      return retriesDone * 500;
    }
  });
};

getCartURL = function getCartURL(cartStream) {
  return cartStream.filter(R.compose(R.not, R.isNil)).map(R.prop('resource_url'));
};

loadCartFromURL = function loadCartFromURL(url) {
  return Bacon.retry({
    source: function source() {
      return resUtil.loadResourceFromURL(url);
    },
    retries: 3,
    isRetryable: function isRetryable(error) {
      return error !== "cart is closed";
    },
    delay: function delay(_ref2) {
      var error = _ref2.error,
          retriesDone = _ref2.retriesDone;

      return retriesDone * 500;
    }
  });
};

cartParams = restaurantStore.closed.filter(R.equals(false)).flatMap(function (allowOrdering) {
  return Bacon.combineWith(restaurantIntegration, userId, portalStore.channel, function (integration, userId, channel) {
    return {
      url: integration.restaurant.cart_url,
      cart: {
        remote_id: integration.permalink,
        user_id: userId,
        integration_url: R.defaultTo('zuppler-' + channel.permalink + '-link://', resUtil.integrationUrl("#/cart")),
        tracking: R.defaultTo('', R.path(['zuppler_tracking'], window)),
        version: 3
      },
      key: integration.restaurant.id + '-' + integration.permalink + '-' + userId
    };
  });
}).skipErrors().skipDuplicates(R.equals);

loadCart = d.stream('load-cart').flatMap(function (key) {
  return storage.getItem('cart', cartKey(key));
}).flatMap(function (url) {
  if (url) {
    return loadCartFromURL(url);
  } else {
    return new Bacon.Error(null);
  }
}).mapError(R.always(null));

createCart = d.stream('create-cart').flatMap(createCart);

_updateSettings = new Bacon.Bus();

cartUpdates = _updateSettings.scan({
  cart: null
}, R.mergeWithKey(_merger)).debounce(300).filter(R.compose(R.not, R.isNil, R.prop('cart'))).changes();

cartUpdated = d.stream('update-cart-action').flatMapLatest(resUtil.updateResource).map(R.prop('cart'));

// cartState = Bacon.update { cart: null, params: null },
//   [ cartParams ], (_, params) ->
//     d.stream('load-cart').push params.key
//     { cart: null, params }

//   [ loadCart ], ({ params }, data ) ->
//     if data
//       { params, cart: data.cart }
//     else
//       d.stream('create-cart').push params
//       { params, cart: null }

//   [ createCart ], ({params}, data) ->
//     if data
//       { params, cart: data.cart }
//     else
//       { params, cart: { service_available: false }}

//   [ cartUpdates ], ({params, cart}, payload ) ->
//     if cart
//       d.stream('update-cart-action').push R.merge payload, url: cart.resource_url

//     { params, cart }

//   [ cartUpdated ], ({params}, cart) ->
//     updateSettings.push cart: null
//     { params, cart }

//   [ d.stream('reload-cart') ], ({params, cart}, _) ->
//     if cart
//       d.stream('load-cart').push params.key
//     { params, cart: null }
cartState = Bacon.once({
  cart: null,
  params: null
});

reloader = d.stream('cart-paused').sampledBy(Bacon.interval(60 * 1000)).filter(R.identity);

d.stream('reload-cart').plug(reloader);

cartStreamData = cartState.map(R.prop('cart')).filter(R.compose(R.not, R.isNil)).filter(R.propEq("accept_online_orders", true)).skipDuplicates(R.equals);

acceptOnlineOrders = cartState.map(R.prop('cart')).filter(R.compose(R.not, R.isNil)).map(R.prop('accept_online_orders')).combine(restaurantStore.closed, function (acceptOrders, isClosed) {
  return acceptOrders && !isClosed;
});

serviceUnavailable = cartState.map(R.prop('cart')).filter(R.compose(R.not, R.isNil)).filter(R.has('service_available')).map(R.compose(R.not, R.prop('service_available')));

d.stream('cart-paused').plug(acceptOnlineOrders.not());

cartStreamErrors = cartStreamData.filter(notNil).map(R.pickAll(['errors', 'info']));

hasErrors = cartStreamErrors.map(R.compose(R.lt(0), R.length, R.keys));

// Walk through all errors fields and collect them
validateCart = function validateCart() {
  return cartStreamData.flatMap(function (cart) {
    return resUtil.loadResourceFromURL(cart.resource_url).map(R.prop('cart'));
  }).flatMap(function (cart) {
    return resUtil.loadResourceFromURL(cart.items.resource_url).map(R.prop('items')).map(R.assocPath(['items', 'data'], R.__, cart));
  }).map(function (cart) {
    var errorCat, itemErrors;
    errorCat = [['errors'], ['items', 'errors'], ['discounts', 'errors'], ['settings', 'errors'], ['settings', 'order', 'errors'],
    // , ['settings', 'tender', 'errors']
    ['settings', 'time', 'errors'], ['settings', 'tip', 'errors']];
    itemErrors = R.map(R.prop('errors'), cart.items.data);
    return R.flatten(R.concat(R.map(R.path(R.__, cart), errorCat), itemErrors));
  }).map(function (errors) {
    return {
      valid: errors.length === 0,
      errors: errors
    };
  });
};

// ************* SAVE CART STATE
notNil = R.pipe(R.isNil, R.not);

cartSavingStream = cartState.filter(R.pipe(R.prop('params'), R.equals(null), R.not)).filter(R.pipe(R.prop('cart'), R.equals(null), R.not)).flatMap(function (_ref3) {
  var cart = _ref3.cart,
      key = _ref3.params.key;

  return storage.setItem("cart", cartKey(key), cart.resource_url);
});

cartSavingStream.onValue(function (result) {});

cartSavingStream.onError(function (result) {
  return console.error(result);
});

// ************* Loading Indicator
// ************* Loading Indicator
isStreamLoading = R.curry(function (dispatcher, streamName, waitS) {
  return dispatcher.stream(streamName).awaiting(waitS);
});

loadingIndicators = {
  'load-cart': loadCart,
  'create-cart': createCart,
  'update-cart-action': cartUpdated
};

busyStream = Bacon.mergeAll(R.append(d.stream('external-loading'), R.map(R.apply(isStreamLoading(d)), R.toPairs(loadingIndicators))));

busyStream.onValue(PlatformUtils.showLoadingIndicator);

// *********** Totals

totalReloader = function totalReloader() {
  return cartStreamData.map(R.prop('totals_resource_url')).throttle(100).sampledBy(d.stream('reload-totals').merge(d.stream('reload-cart'))).flatMap(resUtil.loadResourceFromURL);
};

totalDetailsStream = cartStreamData.map(R.prop('totals_resource_url')).flatMap(resUtil.loadResourceFromURL).take(1).merge(totalReloader()).map(R.prop('totals')).toProperty();

module.exports = {
  activateCart: function activateCart() {},
  validate: validateCart,
  cart: cartStreamData,
  totals: totalDetailsStream,
  errors: cartStreamErrors,
  hasErrors: hasErrors,
  reload: d.stream('reload-cart'),
  reloadTotals: d.stream('reload-totals'),
  reloadCart: function reloadCart() {
    return d.stream('reload-cart').push(new Date());
  },
  loading: busyStream,
  addLoading: function addLoading(stream) {
    return d.stream('external-loading').plug(stream);
  },
  updateSettings: function updateSettings(data) {
    return setTimeout(function () {
      return _updateSettings.push(data);
    }, 0);
  },
  acceptOrders: acceptOnlineOrders,
  serviceUnavailable: serviceUnavailable,
  logout: function logout() {
    return cartState.map(R.path(['params', 'key'])).flatMap(function (key) {
      return storage.deleteItem("cart", cartKey(key));
    });
  }
};